/*
 * ============================================================================
 * Moon Bundle -> ATC price sync (global)
 * ============================================================================
 *
 * WHY THIS EXISTS
 * ---------------
 * The Moon Bundle app and our theme's custom Add-to-Cart button are two
 * separate systems. Our ATC button (#purchase) shows its price in its own node
 * <strong data-ref="price">, but Moon Bundle never updates it. Result: the
 * button stays on the base product price while the widget shows the bundle
 * total (e.g. stuck at EUR109,99 while the customer picked the EUR142,49 bundle).
 *
 * This listens to Moon Bundle's live offer/price streams and writes the
 * selected bundle total into the theme's ATC price node.
 *
 * WHY IT LIVES IN A GLOBAL ASSET
 * ------------------------------
 * Loaded from layout/theme.liquid so it runs on every page. It self-disables
 * where it has nothing to do, so there is no per-template wiring to maintain
 * and any current/future Moon Bundle product is covered automatically.
 *
 * SAFEGUARDS (must never affect non-Moon-Bundle pages)
 * ----------------------------------------------------
 *   1. Bails immediately if there is no #purchase button on the page.
 *   2. Polls for window.MoonBundle only for ~10s, then gives up silently.
 *   3. Wires an instance only if it exposes the expected currentOffer/prices
 *      API (get + subscribe). Anything else is skipped.
 *   4. Everything is wrapped in try/catch and only ever touches
 *      #purchase [data-ref="price"] and the button's js-button-text attribute.
 *      It writes nothing if the offer/price/price-node is missing.
 *
 * IMPLEMENTATION NOTES
 * --------------------
 *   - `currentOffer` and `prices` are the observables that FIRE on change.
 *     Do NOT use `inst.subscription` (name is misleading: it only emits once on
 *     load and is selling-plan related).
 *   - `totalWithUpsellsDiscountedPriceFormatted` is the already-locale-formatted
 *     string the widget shows, so it matches exactly. Swap to
 *     `totalDiscountedPriceFormatted` to exclude upsell add-ons.
 * ============================================================================
 */
(function () {
  'use strict';

  // Safeguard 1: only ever active where the theme's custom ATC button exists.
  if (!document.getElementById('purchase')) return;

  function isObservable(o) {
    return o && typeof o.get === 'function' && typeof o.subscribe === 'function';
  }

  function wire(inst) {
    try {
      if (!inst || !isObservable(inst.currentOffer) || !isObservable(inst.prices)) return;

      function syncAtcPrice() {
        try {
          var offer = inst.currentOffer.get();
          var prices = inst.prices.get();
          var p = offer && prices && prices[offer.id];
          if (!p || !p.totalWithUpsellsDiscountedPriceFormatted) return;

          var formatted = p.totalWithUpsellsDiscountedPriceFormatted; // e.g. "EUR142,49"
          var btn = document.getElementById('purchase');
          if (!btn) return;

          var priceEl = btn.querySelector('[data-ref="price"]');
          if (priceEl) priceEl.textContent = formatted;

          // Keep the theme's reset source in sync so it can't revert the button.
          btn.setAttribute(
            'js-button-text',
            'Add to cart - <strong data-ref="price">' + formatted + '</strong>'
          );
        } catch (e) { /* never break the page */ }
      }

      inst.currentOffer.subscribe(syncAtcPrice); // different bundle selected
      inst.prices.subscribe(syncAtcPrice);       // variant/colour price change within an offer
      syncAtcPrice();                            // correct price on load
    } catch (e) { /* skip this instance */ }
  }

  function wireAll() {
    if (!window.MoonBundle) return false;
    var ids = Object.keys(window.MoonBundle);
    if (!ids.length) return false;
    ids.forEach(function (id) { wire(window.MoonBundle[id]); });
    return true;
  }

  // Safeguard 2: MoonBundle loads async. Poll briefly, then give up silently.
  if (wireAll()) return;
  var tries = 0;
  var timer = setInterval(function () {
    if (wireAll() || ++tries > 100) clearInterval(timer); // ~10s max
  }, 100);
})();
